import apiClient from '@/services/apiClient'

export default {
    /**
     * Get active packs
     * @returns {Promise} API response with active packs
     */
    async getActivePacks() {
        try {
            const response = await apiClient.get('/packs?active=true', {
                skipAuth: true,
            })

            if (response.status === 200) {
                return response.data.data
            } else return null
        } catch (error) {
            console.error('Error fetching active packs:', error)
            throw error
        }
    },
}
